import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Badge, Icon, Switch, Tooltip} from 'antd';
//import AlertDetailModalAnt from './AlertDetailModalAnt.js';
import Loading from '../../commons/Loading.js';

const levelType = {
    'Alarm': 'Alarm',
    'Warning': 'Warning'
};
const resourceType = {
    'CPU': 'CPU',
    'DISK': 'Disk',
    'MEM': 'Mem',
    'DOCKER_CONTAINER_MEM': 'docker_container_mem',
    'DOCKER_CONTAINER_CPU': 'docker_container_cpu'
};
function levelFormatter(cell, row, enumObject) {
    return (
        <div style={{textAlign: 'center'}}>
            {cell === 'Alarm' ? (<Badge status="error"/>) : ( <Badge status="warning"/>) }
        </div>
    );
}

function enumFormatter(cell, row, enumObject) {
    return enumObject[cell];
}

//function detailFormatter(cell, row, enumObject) {
//    return (
//        <AlertDetailModalAnt cell={cell} row={row} from={'platform'}/>
//    )
//}

function filterType(cell, row) {
    return cell;
}

class PlatformAlertAnt extends Component {

    constructor(props) {
        super(props);
        this.state = {
            paData: this.props.paData,
            errorCount: this.props.errorCount,
            fatalCount: this.props.fatalCount,
            loading: this.props.loading,
            isHistory: false
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            paData: nextProps.paData,
            errorCount: nextProps.errorCount,
            fatalCount: nextProps.fatalCount,
            loading: nextProps.loading
        });
    }

    fetch = (params) => {
        /*var history = false;
         if (JSON.stringify(params) != "{}") {
         history = params.history;
         } else {
         history = this.state.isHistory;
         }*/
    }

    onChangeHistory(checked) {
        this.setState({isHistory: checked});
        /*this.fetch({history: checked});*/
    }

    usedPercentFormat = (cell, row, enumObject, rowIndex) => {
        return cell + '%';
    }

    serviceNameFormatter = (cell, row, enumObject, rowIndex) => {
        const tp = (
            <Tooltip title="Container Type">
                <Icon type="question-circle-o"/>
            </Tooltip>
        );
        const showServiceName = (row.resourceType === 'DOCKER_CONTAINER_CPU' || row.resourceType === 'DOCKER_CONTAINER_MEM') && row.serviceName === '' ? row.containerType : row.serviceName;
        const tips = (row.resourceType === 'DOCKER_CONTAINER_CPU' || row.resourceType === 'DOCKER_CONTAINER_MEM') && row.serviceName === '' ? tp : '';
        return (
            <div>
                {showServiceName} {tips}
            </div>
        )
    }

    createCustomToolBar = props => {
        return (
            <div>
                <div className='buttonFiled'>
                    <div className='alertCount alertCount-red'>
                        <Icon type="exclamation-circle" className='alertCountIcon'/>

                        <div className="alertCountContent">
                            <div className="countNumber">{this.state.fatalCount} Alarm</div>
                            {/*<div className="countLevel">Fatal</div>*/}
                        </div>
                    </div>
                    <div className='alertCount alertCount-yellow'>
                        <Icon type="exclamation-circle" className='alertCountIcon'/>

                        <div className="alertCountContent">
                            <div className="countNumber">{this.state.errorCount} Warning</div>
                            {/* <div className="countLevel">Error</div>*/}
                        </div>
                    </div>
                </div>
                <div className='searchFiled'>
                    <div className='alertHistory' style={{display:'none'}}>
                        <Switch className='alertHistorySwitch' defaultChecked={this.state.isHistory}
                                onChange={isHistory => this.onChangeHistory(isHistory)}/>

                        <div className="alertHistoryLabel">Platform History</div>
                    </div>
                    <div className='alertSearch'>
                        { props.components.searchPanel }
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const data = this.state.paData;
        const options = {
            defaultSortName: 'levelPa',
            defaultSortOrder: 'asc',
            noDataText: this.state.loading ? <Loading /> : 'No alert found.',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500
        };
        return (
            <div className=''>
                <BootstrapTable data={ data } search={ true } options={ options } striped hover condensed>
                    <TableHeaderColumn dataField='levelPa' dataFormat={ levelFormatter } formatExtraData={ levelType }
                                       filter={ {type: 'SelectFilter', options: levelType} } filterValue={ filterType }
                                       width="6%">Level</TableHeaderColumn>
                    <TableHeaderColumn dataField='resourceType' dataFormat={ enumFormatter }
                                       formatExtraData={ resourceType }
                                       filter={ {type: 'SelectFilter', options: resourceType, condition:'eq'} }
                                       filterValue={ filterType }
                                       width="12%">Resource Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='description' isKey dataSort={ true }
                                       columnTitle>Description</TableHeaderColumn>
                    <TableHeaderColumn dataField='hostName' dataSort={ true } width="20%" columnTitle>Host
                        Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='serviceName' dataFormat={this.serviceNameFormatter} dataSort={ true }
                                       width="15%">Service Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='containerID' dataSort={ true } width="15%" columnTitle>Container
                        ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='used_percent' dataSort={ true } dataFormat={ this.usedPercentFormat }
                                       width="5%" columnTitle>Used</TableHeaderColumn>
                    <TableHeaderColumn dataField='startTime4Show' dataSort={ true } width="12%" columnTitle>Create
                        Time</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default translate()(PlatformAlertAnt);


// WEBPACK FOOTER //
// ./src/modules/dashboard/PlatformAlertAnt.js